import * as sharedFuelTypesSpecifications from '../../common/vehicleSpecifications/fuelTypes.js'

// Define only the vehicle specifications that are different from the common ones
export const FUEL_TYPES_IDS = {...sharedFuelTypesSpecifications.FUEL_TYPES_IDS}

export const FUEL_TYPES = {...sharedFuelTypesSpecifications.FUEL_TYPES}
